
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiFolderCheckOutline,
	mdiAccountWrench,
	mdiAccountDetails,
	mdiViewDashboard,
	mdiAvTimer,
	mdiAccountAlert,
	mdiBusDoubleDecker,
	mdiCalendar,
	mdiSoccer,
	mdiQrcodeScan,
	mdiAccountSchool,
	mdiCog,
	mdiAccount,
	mdiSchool,
	mdiBookshelf,
	mdiCashMultiple,
	mdiAccountChild,
	mdiDoorOpen,
	mdiAccountOutline,
	mdiAccountCircle,
	mdiBookOpenVariant,
	mdiFaceAgent,
	mdiAccountGroup,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiTimetable,
	mdiCalendarMonth,
	mdiBookOpenPageVariant,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	mdiNotebookEdit,
	mdiNumeric9BoxMultiple,
	mdiTimelineClockOutline,
	mdiWatermark,
	// mdiAccountMultiplePlus,
	mdiPen,
	mdiChartBar
} from '@mdi/js'

const menuAcademicAll = [
	{
		to: '/academic-dashboard',
		icon: mdiViewDashboard,
		label: 'sidebarFin.dashboard'
		// label: 'sidebar.dashboard'
	},
	{
		label: 'sidebarFin.candidates',
		// label: 'Candidates',
		subLabel: 'Submenus Candidates',
		icon: mdiAccountChild,
		menu: [
			{
				to: '/new-batch-registration',
				label: 'sidebarFin.newBatchRegistration',
				// label: 'New Batch Registration',
				icon: mdiDoorOpen
			},
			{
				to: '/candidates-group',
				label: 'sidebarFin.candidatesGroup',
				// label: 'Candidates Group',
				icon: mdiAccountOutline
			},
			{
				to: '/candidate',
				label: 'sidebarFin.candidate',
				// label: 'Candidate',
				icon: mdiAccountOutline
			}
			// {
			// 	to: '/candidates-placement',
			// 	label: 'Candidates Placement',
			// 	icon: mdiAccountOutline
			// }
		]
	},
	{
		label: 'sidebarFin.students',
		// label: 'Student',
		subLabel: 'Submenus Student',
		icon: mdiAccountCircle,
		menu: [
			{
				to: '/students',
				label: 'sidebarFin.students',
				// label: 'Students',
				icon: mdiAccountGroup
			},
			// {
			// 	to: '/class-transfer',
			// 	label: 'Class Transfer',
			// 	icon: mdiAccountMultiplePlus
			// },
			{
				to: '/student-resignation',
				label: 'sidebarFin.resignation',
				// label: 'Resignation',
				icon: mdiAccountGroup
			},
			{
				to: '/graduation',
				label: 'sidebarFin.graduation',
				// label: 'Graduation',
				icon: mdiAccountSchool
			}
		]
	},
	{
		label: 'sidebarFin.parents',
		// label: 'Parents',
		to: '/parent-user',
		icon: mdiAccount
	},
	{
		label: 'sidebarFin.employee',
		// label: 'Employee',
		subLabel: 'Employee',
		icon: mdiAccountCircle,
		menu: [
			{
				to: '/employee',
				label: 'sidebarFin.employee',
				// label: 'Employees',
				icon: mdiAccount
			}
		]
	},
	{
		label: 'sidebarFin.subject',
		// label: 'Subject',
		subLabel: 'Submenus Subject',
		icon: mdiBookOpenVariant,
		menu: [
			{
				to: '/subject',
				label: 'sidebarFin.subject',
				// label: 'Subject',
				icon: mdiBookshelf
			},
			{
				to: '/subject-group',
				label: 'sidebarFin.subjectGroup',
				// label: 'Subject Group',
				icon: mdiBookOpenPageVariant
			},
			{
				to: '/learning-method',
				label: 'sidebarFin.learningMethod',
				// label: 'Learning Method',
				icon: mdiBookPlusMultiple
			},
			{
				to: '/grading-aspects',
				label: 'sidebarFin.gradingAspects',
				// label: 'Grading Aspects',
				icon: mdiHammerScrewdriver
			},
			{
				to: '/assignment-type',
				label: 'sidebarFin.assignmentType',
				// label: 'Assignment Type',
				icon: mdiFormatListBulletedType
			},
			{
				to: '/grading-rule',
				label: 'sidebarFin.gradingRule',
				// label: 'Grading Rule',
				icon: mdiFormatLetterMatches
			},
			{
				to: '/final-score-rule',
				label: 'sidebarFin.finalScoreRule',
				// label: 'Final Score Rule',
				icon: mdiNumeric9BoxMultiple
			},
			{
				to: '/scoreminimum',
				label: 'sidebarFin.passingGrade',
				// label: 'Passing Grade',
				icon: mdiNumeric9BoxMultiple
			},
			{
				to: '/syllabus',
				label: 'sidebarFin.syllabus',
				// label: 'Syllabus',
				icon: mdiNotebookEdit
			},
			{
				to: '/student-paralel-subject',
				label: 'sidebarFin.studentParallelSubject',
				// label: 'Student Parallel Subject',
				icon: mdiAccountDetails
			},
			{
				to: '/student-select-subject',
				label: 'sidebarFin.studentSelectSubject',
				// label: 'Student Subject Selection',
				icon: mdiAccountDetails
			}
		]
	},
	{
		label: 'sidebarFin.extracuricularGroup',
		// label: 'Extracuricular',
		subLabel: 'Submenus Extracuricular',
		icon: mdiSoccer,
		menu: [
			{
				to: '/extracuricular',
				label: 'sidebarFin.extracurricular',
				// label: 'Extracuricular',
				icon: mdiSoccer
			},
			{
				to: '/extracuricular-group',
				label: 'sidebarFin.extracuricularGroup',
				// label: 'Extracuricular Group',
				icon: mdiSoccer
			},
			{
				to: '/extracuricular-student',
				label: 'sidebarFin.extracurricularStudent',
				// label: 'Student Extracuricular',
				icon: mdiAccountDetails
			},
			{
				to: '/extracuricular-student-select',
				label: 'sidebarFin.extracurricularStudentSelect',
				// label: 'Student Extracuricular Selection',
				icon: mdiAccountDetails
			}
		]
	},
	{
		label: 'sidebarFin.teacher',
		// label: 'Teacher',
		subLabel: 'Submenus Teacher',
		icon: mdiClipboardAccount,
		menu: [
			{
				to: '/teacher',
				label: 'sidebarFin.teacher',
				// label: 'Teacher',
				icon: mdiClipboardAccountOutline
			},
			{
				to: '/teacher-extracuricular',
				label: 'sidebarFin.extracurricularTeacher',
				// label: 'Extracurricular Teacher',
				icon: mdiSoccer
			},
			{
				to: '/scan-asset',
				label: 'sidebarFin.scanAsset',
				// label: 'Scan Asset',
				icon: mdiQrcodeScan
			},
			{
				to: '/scan-asset-location',
				label: 'sidebarFin.scanAssetLocation',
				// label: 'Scan Asset Location',
				icon: mdiQrcodeScan
			}
		]
	},
	{
		label: 'sidebarFin.roles',
		// label: 'Roles',
		subLabel: 'Roles',
		icon: mdiFaceAgent,
		menu: [
			{
				to: '/role',
				label: 'sidebarFin.roles',
				// label: 'Role',
				icon: mdiFaceAgent
			},
			{
				to: '/role-group',
				label: 'sidebarFin.roleGroup',
				// label: 'Role Group',
				icon: mdiFaceAgent
			}
		]
	},
	{
		label: 'sidebarFin.transaction', // tidak ada
		// label: 'Transaction',
		subLabel: 'Transaction',
		icon: mdiCashMultiple,
		menu: [
			{
				to: '/transaction-type',
				label: 'sidebarFin.transactionType',
				// label: 'Transaction Type',
				icon: mdiCashMultiple
			},
			{
				to: '/transaction-group',
				label: 'sidebarFin.transactionGroup',
				// label: 'Transaction Group',
				icon: mdiCashMultiple
			}
		]
	},
	{
		label: 'sidebarFin.permissionRequest',
		// label: 'Permission Request',
		subLabel: 'Submenus Teacher',
		icon: mdiFaceAgent,
		menu: [
			{
				to: '/permissions',
				label: 'sidebarFin.permissions',
				// label: 'Permissions',
				icon: mdiFaceAgent
			},
			{
				to: '/permission-reason',
				label: 'sidebarFin.permissionReason',
				// label: 'Permission Reason',
				icon: mdiFaceAgent
			}
		]
	},
	{
		label: 'sidebarFin.schedule',
		// label: 'Schedule',
		subLabel: 'Submenus Schedule',
		icon: mdiTimetable,
		menu: [
			{
				to: '/school-time',
				label: 'sidebarFin.schoolTime',
				// label: 'School Time',
				icon: mdiAvTimer
			},
			{
				to: '/study-time',
				label: 'sidebarFin.studyTime',
				// label: 'Study Time',
				icon: mdiAvTimer
			},
			{
				to: '/schedule',
				label: 'sidebarFin.schedule',
				// label: 'Schedule',
				icon: mdiTimetable
			},
			{
				to: '/extracuricular-schedule',
				label: 'sidebarFin.extracuricularSchedule',
				// label: 'Extracuricular Schedule',
				icon: mdiTimetable
			},
			{
				to: '/calendar',
				label: 'sidebarFin.calendar',
				// label: 'Calendar',
				icon: mdiCalendarMonth
			}
		]
	},
	{
		label: 'sidebarFin.schoolEvents',
		// label: 'School Events',
		to: '/school-events',
		icon: mdiCalendar
	},
	{
		label: 'sidebarFin.attendance',
		// label: 'Attendance',
		subLabel: 'Submenus Attendance',
		icon: mdiAccountArrowLeft,
		menu: [
			{
				to: '/regular-subject-attendance',
				label: 'sidebarFin.regularSubjectAttendance',
				// label: 'Regular Subject',
				icon: mdiAccountArrowLeftOutline
			},
			{
				to: '/parallel-subject',
				label: 'sidebarFin.parallelSubject',
				// label: 'Parallel Subject',
				icon: mdiAccountArrowLeftOutline
			},
			{
				to: '/report-attendance-daily',
				label: 'sidebarFin.dailyAttendanceReport',
				// label: 'Daily Attendance Report',
				icon: mdiAccountAlert
			},
			{
				to: '/summary-report',
				label: 'sidebarFin.summaryReport',
				// label: 'Summary Report',
				icon: mdiAccountAlert
			},
			{
				to: '/assignment-special',
				label: 'sidebarFin.specialAssignment',
				// label: 'Special Assignment',
				icon: mdiBusDoubleDecker
			}
		]
	},
	{
		label: 'sidebarFin.subjectAssessment',
		// label: 'Subject Assessment',
		subLabel: 'Submenus Subject Assessment',
		icon: mdiSchool,
		menu: [
			{
				to: '/lesson-assessment-regular',
				label: 'sidebarFin.regular',
				// label: 'Regular',
				icon: mdiSchool
			},
			{
				to: '/lesson-assessment-parallel',
				label: 'sidebarFin.parallel',
				// label: 'Parallel',
				icon: mdiSchool
			},
			{
				to: '/ledger-homeroom-attidude',
				label: 'sidebarFin.ledgerHomeroomAttidude',
				// label: 'Homeroom Ledger Kokurikuler',
				icon: mdiSchool
			},
			{
				to: '/ledger-homeroom-teacher',
				label: 'sidebarFin.ledgerHomeroomTeacher',
				// label: 'Homeroom Ledger',
				icon: mdiSchool
			},
			{
				to: '/extracuricular-score',
				label: 'sidebarFin.extracuricularScore',
				// label: 'Extracuricular Score',
				icon: mdiSchool
			}
		]
	},
	{
		label: 'sidebarFin.report',
		// label: 'Report',
		to: '/student-raport',
		icon: mdiSchool
	},
	{
		label: 'sidebarFin.settings',
		// label: 'Settings',
		subLabel: 'Submenus Settings',
		icon: mdiCog,
		menu: [
			{
				to: '/schoolidentity',
				label: 'sidebarFin.schoolIdentity',
				// label: 'School Identity',
				icon: mdiSchool
			},
			{
				to: '/branch',
				label: 'sidebarFin.branch',
				// label: 'Branch',
				icon: mdiWatermark
			},
			{
				to: '/users',
				label: 'sidebarFin.users',
				// label: 'Users',
				icon: mdiAccount
			},
			{
				to: '/active-docmag',
				label: 'sidebarFin.activateManagement',
				// label: 'Activate Management',
				icon: mdiFolderCheckOutline
			},
			{
				to: '/unapprove-mechanism',
				label: 'sidebarFin.unapproveMechanism',
				// label: 'Unapprove Mechanism',
				icon: mdiAccountWrench
			},
			{
				to: '/settingattendance',
				label: 'sidebarFin.settingAttendance',
				// label: 'Setting Attendance',
				icon: mdiPen
			},
			{
				to: '/settingspeed',
				label: 'sidebarFin.chartAnalysisSetting',
				// label: 'Chart & Analysis Setting',
				icon: mdiChartBar
			},
			{
				to: '/settingtimeout',
				label: 'sidebarFin.settingtimeout',
				// label: 'Setting Major & Cross Major',
				icon: mdiTimelineClockOutline
			},
			{
				to: '/settingextracuricular',
				label: 'sidebarFin.settingExtracuricular',
				// label: 'Setting Extracuricular',
				icon: mdiTimelineClockOutline
			},
			{
				to: '/settingmodule',
				label: 'sidebarFin.moduleSetting',
				// label: 'Setting Module',
				icon: mdiBookOpenPageVariant
			},
			{
				to: '/template-announcement',
				label: 'sidebarFin.templateAnnouncement',
				// label: 'Template Announcement',
				icon: mdiSchool
			}
		]
	}
]
export default menuAcademicAll
